import { render } from "./CabinetDelivery.vue?vue&type=template&id=56782dc9"
import script from "./CabinetDelivery.vue?vue&type=script&lang=js"
export * from "./CabinetDelivery.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__